import React from 'react';
import ParametroJurosFinanciamentoService from '../../../../lib/api/parametroJurosFinanciamento/parametroJurosFinanciamentoService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroJurosFinanciamento extends React.Component<{},{}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametrosJurosFinanciamento()
    {
        return ParametroJurosFinanciamentoService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return ParametroJurosFinanciamentoService.enviarParametrosAoEventGrid();
    }
    
    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametrosJurosFinanciamento}
                enviarExcelParametros={ParametroJurosFinanciamentoService.enviarExcelParametros}
                deletarExcelParametros={ParametroJurosFinanciamentoService.deletarExcelParametros}
                nomeDoArquivo='Parametro Juros de Financiamento'
            ></TemplateParametro>
        );
    }
}

export default ParametroJurosFinanciamento